import { RPCFactory } from './RequestUtil';
import { store } from '../store/Store';
import RecycleAction from '../actions/RecycleAction';
import { GlobalStateAction } from '../actions/GlobalStateAction';
import { fillPageComponent } from '../consts/routesMap';
import { authRoute, isLeadsRole } from './routes';
import { OutCallConfigAction } from '../actions/OutCallConfigAction';

/**
 * 完成登录之后马上去做的事情，需要通过登录获取到uid等信息
 */
const thingsAfterLogin = (props) => {
  // 获取线索回收的开启状态
  if (isLeadsRole('免登录', '管理员', '超级管理员')) {
    RPCFactory.leadsManage.getRecycleStatus()
      .done((data) => {
        store.dispatch({
          type: RecycleAction.UPDATE,
          payload: {
            enableClaim: data.claimingPauseStatus === 0,
            enableAutoRecycle: data.autoReclaimingPauseStatus === 0,
            enableRuleRelationship: data.reclaimRuleRelationship === 0, // 0 与，1 默认为true(且)
          },
        });
      });
  }
  // 获取外呼设置的配置
  RPCFactory.call.getConfig()
    .done((data) => {
      store.dispatch({
        type: OutCallConfigAction.SET_CONFIG,
        payload: data || {},
      });
    });
  // 获取外呼城市
  RPCFactory.call.getCities()
    .done((data) => {
      const list = data.entities || [];
      store.dispatch({
        type: OutCallConfigAction.SET_CITY,
        payload: list,
      });
    });
};

const leadsDedupKey = 'leads_duplicate_status_';
export const PageUtil = {
  gotoIndex: () => {
    window.location.href = '/';
  },
  gotoAdvertiser: () => {
    const url = PageUtil.getFullPara();
    window.location.href = url;
  },
  gotoSecondLogin: () => {
    const url = PageUtil.getFullPara();
    window.location.href = `${url}#/secondLogin`;
  },
  checkIfNeedSecondLogin: () => {
    const dest = PageUtil.getParaValue('dest');
    if (dest === 'third') {
      return false;
    }
    return true;
  },
  getFullPara: () => {
    const from = PageUtil.getParaValue('from');
    const dest = PageUtil.getParaValue('dest');
    let url = `/advertiser/${window.pageProps.uid}`;
    if (from.length > 0) {
      url = `${url}?from=${PageUtil.getParaValue('from')}`;
    }
    if (from.length > 0 && dest.length > 0) {
      url = `${url}&dest=${PageUtil.getParaValue('dest')}`;
    } else if (dest.length > 0) {
      url = `${url}?dest=${PageUtil.getParaValue('dest')}`;
    }
    return url;
  },
  getParaValue: (para) => {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === para) {
        return pair[1];
      }
    }
    return '';
  },

  getParaValueFromUrl: (url, para) => {
    const query = url.split('?')[1];
    if (!query) return '';
    const vars = query.split('&');
    if (!vars) return '';
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === para) {
        return pair[1];
      }
    }
    return '';
  },
  initWithCallback: (callback) => {
    RPCFactory.init
      .init(window.pageProps.uid)
      .done((data) => {
        if (data) {
          window.pageProps.appId = data.appId;
          window.pageProps.env = data.env;
          window.pageProps.adUserType = data.adUserType;
          window.pageProps.loginName = data.loginName;
          window.pageProps.loginType = data.loginType;
          window.pageProps.token = data.token;
          window.pageProps.operatorRole = data.operatorRole;
          window.pageProps.originRole = data.operatorRole;
          window.pageProps.isInnerAccount = data.isInnerAccount;
          // 免登录看到的东西和超级管理员一样，但操作权限由后台判断
          if (
            data.operatorRole === 'OPERATOR_ROLE_LEADS_OBSERVER' ||
            data.operatorRole === 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
          ) {
            window.pageProps.operatorRole = 'OPERATOR_ROLE_LEADS_MANAGER';
          }
          window.pageProps.operationUserId = data.operationUserId;
          // window.pageProps.operatorRole = 'OPERATOR_ROLE_LEADS_ADOPERATOR';
          window.pageProps.userGroupName = data.userGroupName;
          window.pageProps.userGroupId = data.userGroupId;
          window.pageProps.privileges = data.privileges;
          window.pageProps.privilegesInWhite = data.privilegesInWhite;
          window.pageProps.industryCode1 = data.industryCode1;
          window.pageProps.industryCode2 = data.industryCode2;
          window.pageProps.multiaccount_type = data.multiaccountType;
          window.pageProps.main_account_id = data.mainAccountId;
          window.pageProps.sub_account_ids = data.subAccountIds;
          window.pageProps.mp_sub_account_ids = data.mpSubAccountIds || [];
          window.pageProps.userType = data.userType; // 0 线索通目前的用户   1 企微用户   2 线索通+企微用户（两种功能都有，即有绑定关系）
          window.pageProps.wxWorkUserId = data.wxWorkUserId; // userType=1|2时，表示企微的员工id
          window.pageProps.corpId = data.corpId ? data.corpId : (data.corpIds && data.corpIds.length ? data.corpIds[0] : ''); // 表示企微的企业id
          window.pageProps.corpIds = data.corpIds; // 表示企微的企业ids
          window.pageProps.wxWorkRole = data.wxWorkRole; // 表示企微的角色 1 企微管理员  2企微客服经理 3 企微客服人员 4 企微运营专员
          window.pageProps.qwAuthEnabled = false;
          window.pageProps.isMpAdvertiser = data.isMpAdvertiser;
          window.pageProps.xundaOuterCode = data.xundaOuterCode; // 0: "非讯达" ,600: "X讯达", 601: "车讯达", 602: "房讯达"; 603: "家讯达"
          if (data.loginType === 12) {
            window.pageProps.ssoMultiAccountLoginName = data.loginName;
            window.pageProps.ssoMultiAccountLoginType = 12;
          }
          // 特殊逻辑，通过后端返回字段控制能否访问粉丝运营-个微好友管理页面
          if (data.inPersonalWechatWhiteList) {
            window.pageProps.privileges.push('WECHAT_FRIEND_VISIBLE');
          }
        }
        thingsAfterLogin(window.pageProps);
        callback(data);
      })
      .fail((ret, msg) => {
        store.dispatch({
          type: GlobalStateAction.SHOW_TIPS,
          message: `系统初始化错误，请稍后重试:${msg}`,
          callBack: () => {
            window.location.href = '/';
          },
        });
      });
  },
  getWeixinUserNameDisplayEnv: () => {
    if (window.pageProps.corpId) {
      RPCFactory.qwSidebar
        .getConfig()
        .done((data) => {
          window.pageProps.timestamp = data.timestamp; // 生成签名的时间戳 s
          window.pageProps.nonceStr = data.nonceStr; // 生成签名的随机串
          window.pageProps.signature = data.signature; // 签名
          window.pageProps.corpSignature = data.corpSignature;
          window.pageProps.agentId = data.agentId; // agentId
          PageUtil.configNameDisplayEnv();
        })
        .fail((code, msg) => {
          alert(`get config fail ${msg}`);
        });
    }
  },
  getWeixinConfig: () => {
    if (!window.pageProps.corpId) {
      console.error('missing corpId');
      return;
    }
    RPCFactory.qwSidebar
      .getConfig()
      .done((data) => {
        window.pageProps.timestamp = data.timestamp; // 生成签名的时间戳 s
        window.pageProps.nonceStr = data.nonceStr; // 生成签名的随机串
        window.pageProps.signature = data.signature; // 签名
        window.pageProps.corpSignature = data.corpSignature;
        window.pageProps.agentId = data.agentId; // agentId
        PageUtil.configWeixinEnv();
        // PageUtil.configNameDisplayEnv();
      })
      .fail((code, msg) => {
        alert(`get config fail ${msg}`);
      });
  },
  getQwContext: () => {
    window.wx.invoke('getContext', {}, (res) => {
      // console.log('getQwContext', res);
      if (res.err_msg === 'getContext:ok') {
        const { entry } = res; // 返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools、chat_attachment
        window.pageProps.entry = entry;
      }
      // 错误处理
    });
  },
  configNameDisplayEnv: () => {
    window.wx.agentConfig({
      corpid: window.pageProps.corpId,
      agentid: window.pageProps.agentId,
      timestamp: window.pageProps.timestamp,
      nonceStr: window.pageProps.nonceStr,
      signature: window.pageProps.signature,
      jsApiList: ['getCurExternalContact', 'getContext'],
      success: (res) => {
        window.WWOpenData.bind(document.querySelector('ww-open-data'));
      },
      fail(res) {
        if (res.errMsg.indexOf('function not exist') > -1) {
          alert('版本过低请升级');
        }
      },
    });
  },
  configWeixinEnv: () => {
    window.wx.config({
      beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: window.pageProps.corpId, // 必填，企业微信的corpID
      timestamp: window.pageProps.timestamp, // 必填，生成签名的时间戳
      nonceStr: window.pageProps.nonceStr, // 必填，生成签名的随机串
      signature: window.pageProps.corpSignature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ['getCurExternalContact', 'getContext'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });
    window.wx.ready(() => {
      window.wx.checkJsApi({
        jsApiList: ['getCurExternalContact'],
        success() {
          window.wx.agentConfig({
            corpid: window.pageProps.corpId,
            agentid: window.pageProps.agentId,
            timestamp: window.pageProps.timestamp,
            nonceStr: window.pageProps.nonceStr,
            signature: window.pageProps.signature,
            jsApiList: ['getCurExternalContact', 'getContext'],
            success: (res) => {
              // 回调
              window.wx.invoke('getCurExternalContact', {}, (res) => {
                if (res.err_msg === 'getCurExternalContact:ok') {
                  window.pageProps.externalUserId = res.userId; // 返回当前外部联系人userId
                } else {
                  // 错误处理
                }
              });
              window.WWOpenData.bind(document.querySelector('ww-open-data'));
              console.log('get ww success!!!!!!!!!!!!!!!!');
              PageUtil.getQwContext();
            },
            fail(res) {
              if (res.errMsg.indexOf('function not exist') > -1) {
                alert('版本过低请升级');
              }
            },
          });
        },
        fail(res) {
          if (res && res.err_msg) {
            alert(`checkJsApi 接口调用失败${res.err_msg}`);
          }
        },
      });
    });
  },
  /**
   * @returns 当前登录角色有权访问的路由
  */
  getAuthedRoutes: () => {
    // 利用 react-router-v5 的特性聚合路由
    // 避免不同路由相同页面组件会重新加载的情况
    const visiableRoutes = authRoute();
    const routesWithPageComponent = fillPageComponent(visiableRoutes);
    const flatedRoutes = PageUtil.flatRoutes(routesWithPageComponent);
    const map = new Map();
    flatedRoutes.forEach((item) => {
      const key = item.component;
      const path = map.get(key);
      if (!map.has(key)) {
        map.set(key, item.path);
      } else {
        map.set(key, [].concat.apply([], [path, item.path]));
      }
    });
    const arr = [];
    for (const [k, v] of map) {
      arr.push({ path: v, component: k });
    }
    return arr;
  },
  /**
   * 将树形结构展平成一维的
   */
  flatRoutes: (arr) => {
    const routeStore = [];
    /**
     * 有些二级菜单没有对应的页面组件，需要填充为第一个子菜单的页面组件
     */
    const findDefaultComponent = (childRoutes) => {
      if (!Array.isArray(childRoutes) || childRoutes.length < 1) return null;
      if (childRoutes[0].component) return childRoutes[0].component;
      // component === null
      // 子菜单也是没有页面的多级菜单，递归
      return findDefaultComponent(childRoutes[0].routes);
    };

    const flat = (routeItems) => {
      if (!Array.isArray(routeItems)) return;
      routeItems.forEach((item) => {
        const route = { ...item };
        delete route.routes;
        // 没有页面组件，是多级菜单，填充下一级菜单的页面
        if (route.component === null) {
          route.component = findDefaultComponent(item.routes);
        }
        // 复查，一个菜单下面不能没有空页面的路由
        if (route.component === null) {
          throw new Error(`没有找到对应路由的页面组件${  route.path}`);
        }
        routeStore.push(route);
        flat(item.routes);
      });
    };

    flat(arr);
    return routeStore.reverse();
  },
  getLeadsDedupFromStorage: () => {
    const leadsDedupStatus = localStorage.getItem(`${leadsDedupKey}${window.pageProps.uid}`);
    return leadsDedupStatus === 'true';
  },
  setLeadsDedupToStorage: (status) => {
    localStorage.setItem(`${leadsDedupKey}${window.pageProps.uid}`, status ? 'true' : 'false');
  },
};
